export const messages = {
  en: {
    locationManage: {
      queryCondition: 'Query Conditions',
      deviceLocation: 'Device Location',
      enterLocationCode: 'Enter location code',
      enterLocationName: 'Enter location name',
      selectLocationType: 'Select location type',
      locationCode: 'Location Code',
      locationName: 'Location Name',
      locationType: 'Location Type',
      locationObject: 'Location Object',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteLocation: 'Confirm to delete this location?',
      selectBuilding: 'Select building',
      selectUnit: 'Select unit',
      selectRoom: 'Select room',
      selectGuardBox: 'Select guard box',
      selectParkingArea: 'Select parking area',
      selectCompany: 'Select company',
      selectDepartment: 'Select department',
      selectOrg: 'Select organization',
      selectOrgRequired: 'Please select related organization',
      selectOrgFirst: 'Please select an organization first',
      belongBuilding: 'Belong Building',
      belongUnit: 'Belong Unit',
      belongGuardBox: 'Belong Guard Box',
      belongDepartment: 'Belong Department',
      modifyBuilding: 'Modify Building',
      modifyUnit: 'Modify Unit',
      modifyGuardBox: 'Modify Guard Box',
      modifyParkingLot: 'Modify Parking Lot',
      community: 'Community',
      building: 'Building',
      unit: 'Unit',
      room: 'Room',
      guardBox: 'Guard Box',
      department: 'Department',
      parkingLot: 'Parking Lot',
      buildingUnit: 'Building',
      noOwner: 'No Owner',
      locationNameRequired: 'Location name is required',
      locationNameMaxLength: 'Location name cannot exceed 100 characters',
      locationTypeRequired: 'Location type is required',
      fetchError: 'Failed to fetch location data'
    }
  },
  zh: {
    locationManage: {
      queryCondition: '查询条件',
      deviceLocation: '设备位置',
      enterLocationCode: '请输入位置编码',
      enterLocationName: '请输入位置名称',
      selectLocationType: '请选择位置类型',
      locationCode: '位置编码',
      locationName: '位置名称',
      locationType: '位置类型',
      locationObject: '位置对象',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmOperation: '请确认您的操作',
      confirmDeleteLocation: '确定删除该位置管理?',
      selectBuilding: '请选择楼栋',
      selectUnit: '请选择单元',
      selectRoom: '请选择房屋',
      selectGuardBox: '请选择岗亭',
      selectParkingArea: '请选择停车场',
      selectCompany: '请选择公司',
      selectDepartment: '选择部门',
      selectOrg: '选择组织',
      selectOrgRequired: '必填，请填写关联组织',
      selectOrgFirst: '请先选择组织',
      belongBuilding: '归属楼栋',
      belongUnit: '归属单元',
      belongGuardBox: '归属岗亭',
      belongDepartment: '归属部门',
      modifyBuilding: '修改楼栋',
      modifyUnit: '修改单元',
      modifyGuardBox: '修改岗亭',
      modifyParkingLot: '修改停车场',
      community: '小区',
      building: '楼栋',
      unit: '单元',
      room: '房屋',
      guardBox: '岗亭',
      department: '部门',
      parkingLot: '停车场',
      buildingUnit: '号楼',
      noOwner: '无业主',
      locationNameRequired: '位置名称不能为空',
      locationNameMaxLength: '位置名称不能超过100位',
      locationTypeRequired: '位置类型不能为空',
fetchError: '获取位置数据失败'
    }
  },
  'zh-TW': {
    locationManage: {
      queryCondition: '查詢條件',
      deviceLocation: '設備位置',
      enterLocationCode: '請輸入位置編碼',
      enterLocationName: '請輸入位置名稱',
      selectLocationType: '請選擇位置類型',
      locationCode: '位置編碼',
      locationName: '位置名稱',
      locationType: '位置類型',
      locationObject: '位置對象',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmOperation: '請確認您的操作',
      confirmDeleteLocation: '確定刪除該位置管理?',
      selectBuilding: '請選擇樓棟',
      selectUnit: '請選擇單元',
      selectRoom: '請選擇房屋',
      selectGuardBox: '請選擇崗亭',
      selectParkingArea: '請選擇停車場',
      selectCompany: '請選擇公司',
      selectDepartment: '選擇部門',
      selectOrg: '選擇組織',
      selectOrgRequired: '必填，請填寫關聯組織',
      selectOrgFirst: '請先選擇組織',
      belongBuilding: '歸屬樓棟',
      belongUnit: '歸屬單元',
      belongGuardBox: '歸屬崗亭',
      belongDepartment: '歸屬部門',
      modifyBuilding: '修改樓棟',
      modifyUnit: '修改單元',
      modifyGuardBox: '修改崗亭',
      modifyParkingLot: '修改停車場',
      community: '小區',
      building: '樓棟',
      unit: '單元',
      room: '房屋',
      guardBox: '崗亭',
      department: '部門',
      parkingLot: '停車場',
      buildingUnit: '號樓',
      noOwner: '無業主',
      locationNameRequired: '位置名稱不能為空',
      locationNameMaxLength: '位置名稱不能超過100位',
      locationTypeRequired: '位置類型不能為空',
      fetchError: '獲取位置數據失敗'
    }
  }
}